module.exports = __webpack_public_path__ + "623e4dda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_home_address.png
// module id = 1256
// module chunks = 0